import loadGoogleMapsApi from "load-google-maps-api";
import "dotenv";

export async function geocodeAddress(address) {
  return new Promise((resolve, reject) => {
    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK' && results.length) {
        resolve(results);
      } else {
        reject(new Error('Invalid address.'));
      }
    });
  });
};

export async function getLatLngFromAddress(address) {
  
  const results = await geocodeAddress(address);
  let loc = { lat: 0, lng: 0 };

  if (results.length) loc = results[0].geometry.location;

  return { lat: loc.lat, lng: loc.lng };
}

export async function getDistanceBetweenTwoLocation(origin, destination) {
  return new Promise((resolve, reject) => {
    // loadGoogleMapsApi({ key: GoogleMapAPIKEY })
    loadGoogleMapsApi({ key: process.env.REACT_APP_GOOGLE_API_KEY })
      .then(googleMaps => {
        const matrixcls = new googleMaps.DistanceMatrixService();
        matrixcls.getDistanceMatrix(
          {
            // origins: [new googleMaps.LatLng(origin.lat, origin.lng)],
            // destinations: [new googleMaps.LatLng(destination.lat, origin.lng)],
            origins: [origin], // based on address
            destinations: [destination], // based on address
            travelMode: googleMaps.TravelMode.DRIVING
          },
          response => {
            // console.log(status);
            // console.log(JSON.stringify(response));
            resolve(response);
          }
        );
      })
      .catch(error => {
        reject(error);
        console.error(error);
      });
  });
}

export const fetchAddressLabel = async (placeId) => {
  try {
    const { Place } = await window.google.maps.importLibrary("places");

    if (!Place) {
      throw new Error('Google Maps Places API (Place) is not available.');
    }

    const place = new Place({ id: placeId });

    const { place: result } = await place.fetchFields({
      fields: ['displayName', 'addressComponents'],
    });

    if (!result) {
      throw new Error('Label fetch failed: No place found.');
    }

    // New API: displayName replaces old name
    const name = result.displayName?.text || result.displayName || '';

    // addressComponents is now camelCase, not address_components
    const components = result.addressComponents || [];
    const premise = components.find((c) => c.types.includes('premise'))?.longText || '';
    const subpremise = components.find((c) => c.types.includes('subpremise'))?.longText || '';

    return { name, premise, subpremise };
  } catch (err) {
    console.error('Error fetching address label:', err);
    throw err;
  }
};

export const getAddressDetails = async (address) => {
  const results = await geocodeAddress(address);
  const hasLabel = !/^\d/.test(address);
  const addressRes = {
    userplace_id: null,
    label: "",
    addressLine: "",
    addressLine1: "",
    city: "",
    state: "",
    zipcode: "",
    county: "",
    latitude: 0,
    longitude: 0,
    location_type: 2,
  };

  const firstValidResult =
    results.find(
      (res) =>
        res.address_components.some((ac) => ac.types.includes('street_number')) &&
        res.address_components.some((ac) => ac.types.includes('route'))
    ) || results[0];

  if (!firstValidResult) {
    throw new Error('No valid address found.');
  }

  const location = firstValidResult.geometry.location;
  const components = firstValidResult.address_components;

  let streetNumber = '';
  let route = '';
  let city = '';
  let state = '';
  let zipcode = '';
  let county = '';
  let premise = '';
  let subpremise = null;

  components.forEach((comp) => {
    const types = comp.types;

    if (types.includes('street_number')) streetNumber = comp.long_name;
    if (types.includes('route')) route = comp.long_name;
    if (types.includes('locality') || types.includes('sublocality')) city = comp.long_name;
    if (types.includes('postal_code')) zipcode = comp.short_name;
    if (types.includes('administrative_area_level_2')) county = comp.long_name;
    if (types[0] === 'administrative_area_level_1' && types[1] === 'political') {
      state = comp.short_name;
    }
    if (types.includes('premise')) premise = comp.long_name;
    if (types.includes('subpremise')) subpremise = comp.long_name;
  });

  // Special case for Los Angeles
  if (city.toLowerCase() === 'los angeles') {
    const neighborhood = components.find((comp) => comp.types.includes('neighborhood'));
    if (neighborhood?.long_name) {
      city = neighborhood.long_name;
    }
  }

  const addressLine1 = `${streetNumber} ${route}`.trim();
  if (!addressLine1) {
    throw new Error('Incomplete address; string');
  }

  addressRes.addressLine1 = addressLine1;

  addressRes.city = city;
  addressRes.state = state;
  addressRes.zipcode = zipcode;
  addressRes.county = county;
  addressRes.latitude = location.lat();
  addressRes.longitude = location.lng();
  addressRes.completeAddress = firstValidResult.formatted_address;
  addressRes.subpremise = subpremise;
  addressRes.premsise = premise;

  try {
    let label = null;
    // if string does not start with a digit, fetch label
    if (hasLabel) {
      label = await fetchAddressLabel(firstValidResult.place_id);
    }

    if (label) {
      addressRes.label = label.name;
      premise = label.premise;
    }

    addressRes.addressLine1 = `${addressRes.addressLine1} ${premise} ${
      subpremise ? (subpremise.startsWith('#') ? subpremise.trim() : `#${subpremise}`.trim()) : ''
    }`.trim();
  } catch (err) {
    console.error('Label fetch failed:', err);
  }

  // other places in the code uses this property, returning it for now, but we should refactor those to use similar
  addressRes.addressLine = addressRes.addressLine1;
 
  return addressRes;
};